const Graph = require('./BaseGraph')

module.exports = class NotificationGraph extends Graph 
{
    constructor(apiDomain, path="notification")
    {
        super(apiDomain, path)
    }

    
    setNotification(fields, params=null)
    {
        if (params)
            return { type: 'createNotificationMessage', query: `mutation {
                createNotificationMessage(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createNotificationMessage', query: `mutation createNotificationMessage ($code: String!, $user_id: Int!, $search_values: String, $new_values: String, $remarks: String, $system_generated: Boolean) {
            createNotificationMessage(code: $code, user_id: $user_id, search_values: $search_values, new_values: $new_values, remarks: $remarks, system_generated: $system_generated)
            ${this.queryFields(fields)}
        }` }
    }


    notifificationQuery(fields, params=null)
    {
        if (params)
            return { type: 'notificationMessage', query: this.queryString('notificationMessage', fields, params)}

        return { type: 'notificationMessage', query: `query notificationMessage ($id: Int!, $is_sent: Int, $is_read: Int) {
            notificationMessage(id: $id, is_sent: $is_sent, is_read: $is_read)
            ${this.queryFields(fields)}
        }` }
    }

    notifificationsQuery(fields, params=null)
    {
        if (params)
            return { type: 'notificationMessages', query: this.queryString('notificationMessages', fields, params)}

        return { type: 'notificationMessages', query: `query notificationMessages ($user_id: String, $contact_id: String, $notification_id: Int, $is_sent: Int, $is_read: Int) {
            notificationMessages(user_id: $user_id, contact_id: $contact_id, notification_id: $notification_id, is_sent: $is_sent, is_read: $is_read)
            ${this.queryFields(fields)}
        }` }
    }


}